import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import gtm from '../../utils/gtm';

/**
 * Component to track page views in Google Tag Manager
 * Automatically tracks page views when route changes
 */
const PageViewTracker = () => {
    const location = useLocation();

    useEffect(() => {
        gtm.trackPageView(location.pathname + location.search);
    }, [location]);

    return null;
};

export default PageViewTracker;
